import './header.scss';
import { Logo } from "../logo/logo"

export const Header = () => {
  return <div className="header-container"><Logo /><h1>CHATSOMETHING</h1></div>
}